import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HeaderScrollService {
  private isScrolledSubject = new BehaviorSubject<boolean>(false);
  public isScrolled$: Observable<boolean> =
    this.isScrolledSubject.asObservable();

  setScrolled(isScrolled: boolean): void {
    this.isScrolledSubject.next(isScrolled);
  }

  protected get isScrolled(): boolean {
    return this.isScrolledSubject.value;
  }
}
